module.exports = __webpack_public_path__ + "img/1991-Die-Presse.23938b54.jpg";